import { Box } from "@mui/material";
import BackToFunction from "../../../../Curator/Components/BackToFunction";
import CommonLayout from "../../CommonComponent/CommonLayout";
import BuilderFooter from "../BuilderFooter/BuilderFooter";

const BuilderLayout = ({
  children,
  label,
  form,
  backlabel,
  back,
  disabled,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1, // Allows it to grow in its parent's space
        minHeight: 0, // Prevents overflow if parent uses minHeight
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1, // This makes it expand to available height
          padding: "24px 48px",
          gap: "24px",
          overflow: "auto", // Optional: make content scrollable if needed
        }}
      >
        <BackToFunction label={backlabel} handleBack={back} />
        <CommonLayout>{children}</CommonLayout>
      </Box>
      <Box sx={{ flexShrink: 0 }}>
        <BuilderFooter
          label={label}
          form={form}
          handleBack={back}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};

export default BuilderLayout;
